module.exports = __webpack_public_path__ + "0439858775eba919df435fce81b20dd5.svg";